<div class="manage-bookmarks-wrapper container ">
  <div class="sidebar">
    <p class="sidebar-heading">Your Bookmark</p>
    <div class="sidebar-items" *ngFor="let bookmark of Bookmarks">
      <a routerLinkActive="selected" [routerLink]="[bookmark.id]" class="sidebar-item">{{bookmark.title}}</a>
    </div>
  </div>
  <div class="content has-blur-white-bg">
    <ng-container>
      <app-edit-bookmark></app-edit-bookmark>
    </ng-container>
  </div>
</div>